export default __webpack_public_path__ + "static/media/019-submarine.5bf9c31f.png";